<template>
  <div width="100%">
    <header aria-labelledby=“header-label”>
      <!--link rel="icon" href="/favicon.ico" -->
      <v-container role="none" class="justify-center align-center">
        <v-row class="align-start">
          <v-col cols="12" md="auto" class="d-flex align-start py-1">
            <a href="https://www.city.yokohama.lg.jp/" 
               title="横浜市トップページ表示"
               class="hlogo">
                  <v-img justify="center" height="auto" min-width="100pt" src="logopluscolor.jpg" alt="横浜市"></v-img>
            </a>
          </v-col>
        </v-row>
        <v-row class="d-flex flex-column flex-md-row justify-center">
          <v-col cols="12" md="auto" class="text-center py-0 pr-0">
            <h1 class="align-end" id="header-label">横浜市コールセンター</h1>
          </v-col>
          <v-col cols="12" md="auto" class="text-center py-0 pl-0">
            <h1 class="align-end" id="header-label">{{currentTitle}}</h1>
          </v-col>
        </v-row>
      </v-container>
    </header>

    <!-- ここでページのコンテンツが変わる -->
    <main>
      <router-view />
    </main>
    <footer class="text-center">
      <nav v-if="currentFooter" role="navigation">
        <router-link to="/accessibility" target="_blank">ウェブアクセシビリティ</router-link>
      </nav>
    </footer>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const route = useRoute()
const currentTitle = computed(() => route.meta.title || '問合せフォーム')
const currentFooter = computed(() => route.meta.footer)
</script>

<script>
export default {
  name: 'DefaultLayout',
}
</script>

<style scoped>
html {
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

body
{
  font-size: 10pt;
}

main {
  padding-bottom: 50px;
}

h1 {
  font-size: 1.4em;
  word-wrap: break-word;
  word-break: break-word;
  padding: 0;
}

.hlogo
{
  text-align: center;
  justify-content: center;
}

header
{
  background-color: white;
  padding: 10px;
}

footer
{
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: white;
  padding: 10px;
  text-align: center;
}

nav a {
  margin-right: 15px;
}

.v-container
{
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

</style>